import { createFileRoute } from "@tanstack/react-router";
import { safeJsonLd } from "@/lib/structured-data";
import { bookingPageCrumbs, getClinicStructuredData } from "@/lib/structured-data/clinic";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/plano")({
  head: () => ({
    meta: [
      // Indexable since 1 Oct 2026 (approved by Anthony): the page had
      // organic traffic while it was noindex. All clinic booking pages and
      // /schedule-a-consult/ are indexable. Quick quote pages stay noindex.
      // Title and meta: the WordPress copy (staging, 6 Oct 2026), punctuation fixed.
      // H1 names the procedure and the city (rule from Anthony, 6 Oct 2026).
      { title: "Schedule Your FREE Hair Transplant Consultation in Plano, TX" },
      { name: "description", content: "Schedule your free hair restoration consult with RESTORE in Plano, TX. You can do it in person or virtually. Our client advisors will answer your questions." },
      { property: "og:title", content: "Schedule Your FREE Hair Transplant Consultation in Plano, TX" },
      { property: "og:description", content: "Schedule your free hair restoration consult with RESTORE in Plano, TX. You can do it in person or virtually. Our client advisors will answer your questions." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/plano/",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({
          "@graph": getClinicStructuredData("plano", bookingPageCrumbs("Plano", "/schedule-a-consult/plano/")),
        }),
      },
    ],
  }),
  component: SchedulePlanoPage,
});

function SchedulePlanoPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Transplant Consultation in Plano, TX
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Plano.
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&owner=24213130&appointmentType=49647474" />
        </div>
      </main>
      <Footer />
    </div>
  );
}